import clsx from 'clsx';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import { Dropdown, DropdownItem } from 'modules/user-page/components/common/Dropdown';
import { ColorId, getCursorColorBgClass, getCursorColorOption, getCursorColorOptions } from 'utils/highlight-colors';

export type ColorDropdownOption = DropdownItem & { color: string };

export interface ColorDropDownProps {
  className?: string;
  isPDF: boolean;
  onSelectionChange: (option: DropdownItem) => void;
  selectedColorId: ColorId;
}

export const ColorDropDown: React.FC<ColorDropDownProps> = ({ className = '', isPDF, onSelectionChange, selectedColorId }) => {
  const options = getCursorColorOptions(isPDF);
  const selectedOption = getCursorColorOption(selectedColorId, isPDF);
  const selectedOptionBGColorClassName = getCursorColorBgClass(selectedColorId, isPDF);

  const fontClasses = 'font-serif font-normal text-sm leading-5';

  return (
    <Dropdown
      className={twMerge(
        fontClasses,
        'hover:opacity-75 active:opacity-50 bg-transparent hover:bg-transparent active:bg-transparent pr-0',
        isPDF ? 'text-black' : 'text-icn-txt-prim',
        className
      )}
      getOptionValueClassName={option => {
        const bgColorClassName = getCursorColorBgClass(option.id as ColorId, isPDF);
        const isSelected = option.id === selectedOption.id;

        const baseClasses = `${fontClasses} ${isPDF ? 'text-black' : 'text-icn-txt-prim'} ${bgColorClassName} hover:${bgColorClassName} active:${bgColorClassName} px-3`;
        const hoverClasses = isSelected ? '' : 'hover:opacity-75 active:opacity-50';
        const roundedClass = isSelected ? 'rounded-150' : 'rounded-md';

        return clsx(baseClasses, roundedClass, hoverClasses);
      }}
      getOptionValueWrapperClassName={option => {
        const isSelected = (option as ColorDropdownOption).id === selectedOption.id;
        const optionColor = (option as ColorDropdownOption).color;

        return isSelected
          ? `flex items-center justify-center border-2 border-${optionColor} rounded-[9px] p-[1px]`
          : `flex items-center justify-center border-2 border-transparent rounded-[9px] p-[1px]`;
      }}
      handleSelectOption={onSelectionChange}
      optionClassName="min-w-0 m-0 px-2 pt-[4px] pb-0 bg-transparent hover:bg-transparent active:bg-transparent"
      options={options.map(option => ({ ...option, value: 'Aa' }))}
      menuClassName="min-w-0 py-[7px] px-0 right-2"
      menuOpenClassName="opacity-75"
      selectedValue={{ ...selectedOption, value: 'Aa' }}
      showCheckmark={false}
      valueClassName={`${fontClasses} ${isPDF ? 'text-black' : 'text-icn-txt-prim'} ${selectedOptionBGColorClassName} hover:${selectedOptionBGColorClassName} active:${selectedOptionBGColorClassName} rounded-150 px-3`}
    />
  );
};
